import React, { useEffect, useState } from "react";
import { Col, Row, Tooltip } from "antd";
import { NavLink, useHistory } from "react-router-dom";
import { getUrlCode } from "../../../../utils/CustomFunc";

const Angela = (props) => {
  // const [headerSetting, setHeaderSetting] = useState(null);
  useEffect(() => {}, [props]);
  // console.log("Angela");
  // console.log(props.config);
  const kpiRows = props.config.chartDiv.kpiRows;
  
  

  return (
    <React.Fragment>
      <div style={props.config.chartDiv}>
        <Row justify="space-around" align="middle">
          <Col flex="60px" style={{}}>
            <Tooltip title={"<MyLogoTitle>"} placement="right">
              <NavLink to={`/v02/${getUrlCode()}/dashboard`}>
                <img
                  className="spin"
                  src={props.data.img.src}
                  alt={props.data.img.alt}
                  style={props.config.img}
                ></img>
              </NavLink>
            </Tooltip>
          </Col>
          <Col flex="110px">
            <div style={props.config.h1}>{props.data.h1.txt}</div>
            <div style={props.config.h2}>{props.data.h2.txt}</div>
          </Col>
        </Row>

        
          <Row justify="space-around" align="middle">
            <Col style={{ width: "50%" }}>
              <div>
                <span style={props.config.kpi1.name}>
                  {" "}
                  {props.data.kpi1.name.txt}
                </span>
                <span style={props.config.kpi1.val}>
                  {" "}
                  {props.data.kpi1.val.txt}
                </span>
              </div>
              {kpiRows > 1 && (
              <div>
                <span style={props.config.kpi3.name}>
                  {" "}
                  {props.data.kpi3.name.txt}
                </span>
                <span style={props.config.kpi3.val}>
                  {" "}
                  {props.data.kpi3.val.txt}
                </span>
              </div>)}
              {kpiRows > 2 && (
              <div>
                <span style={props.config.kpi5.name}>
                  {" "}
                  {props.data.kpi5.name.txt}
                </span>
                <span style={props.config.kpi5.val}>
                  {" "}
                  {props.data.kpi5.val.txt}
                </span>
              </div>)}
            </Col>
            <Col style={{ width: "50%" }}>
              <div>
                <span style={props.config.kpi2.name}>
                  {" "}
                  {props.data.kpi2.name.txt}
                </span>
                <span style={props.config.kpi2.val}>
                  {" "}
                  {props.data.kpi2.val.txt}
                </span>
              </div>
              {kpiRows > 1 && (
              <div>
                <span style={props.config.kpi4.name}>
                  {" "}
                  {props.data.kpi4.name.txt}
                </span>
                <span style={props.config.kpi4.val}>
                  {" "}
                  {props.data.kpi4.val.txt}
                </span>
              </div>)}
              {kpiRows > 2 && (
              <div>
                <span style={props.config.kpi6.name}>
                  {" "}
                  {props.data.kpi6.name.txt}
                </span>
                <span style={props.config.kpi6.val}>
                  {" "}
                  {props.data.kpi6.val.txt}
                </span>
              </div>)}
            </Col>
          </Row>
     



      </div>
    </React.Fragment>
  );
};
export default Angela;
